__turbopack_context__.v({
  "chevron": "_fXh2a_chevron",
  "label": "_fXh2a_label",
  "labelDisabled": "_fXh2a_labelDisabled",
  "selectorGroup": "_fXh2a_selectorGroup",
  "trigger": "_fXh2a_trigger",
  "triggerDisabled": "_fXh2a_triggerDisabled",
  "triggerIcon": "_fXh2a_triggerIcon",
  "triggerText": "_fXh2a_triggerText",
  "wrap": "_fXh2a_wrap",
});
